/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import {
  BOOK_NOW,
  HIDE_PRICES,
  MYSAFETY_IMAGE,
  NEW,
  NO_RATINGS,
  ORDER_FIELD,
  VIEW_PRICES,
  WHY_BOOK_WITH_US_TEXT
} from '../../constants/miscellaneousConstants';
import {
  formatText,
  getCarTypeForDisplay,
  getColorGradientClassByRating,
  formatBookingPersuasion
} from '../../utils/stringUtils';
import { Context } from '../../AppContext';
import { RouteCabsFareCards } from '../RouteCabsFareCards/RouteCabsFareCards';
import { isDesktop, isSSR } from '../../utils/commonUtils';
export const RouteCabsV2Desktop = ({
  isShown,
  data,
  packageAvailabilityOrderMap,
  setPackageAvailabilityOrderMap,
  getModelNameString,
  getModelDescriptionString,
  getFirstVisibleCardIndex,
  redirect,
  tripBenefits
}: {
  isShown: (cabInfo: any) => boolean;
  data;
  packageAvailabilityOrderMap;
  setPackageAvailabilityOrderMap;
  getModelNameString;
  getModelDescriptionString;
  getFirstVisibleCardIndex;
  redirect;
  tripBenefits;
}) => {
  const { trackTemplateEvent } = useContext(Context);
  return (
    <table
      style={{
        borderSpacing: '0px 15px',
        width: '100%',
        border: '1px solid #cecece'
      }}
      className={`noBorder tableBorderSpacing appendBottom40`}
    >
      <tbody>
        {' '}
        {data &&
          data.map((cabInfo, idx) => {
            const {
              persuasions,
              cab_description,
              cab_description_v2,
              desktop_claim_persuasions,
              my_safety,
              strike_off_discount_text,
              strike_off_discount_textV2,
              reviewURL,
              type,
              booking_count_persuasion
            } = cabInfo;
            return (
              <>
                <tr
                  key={`cabCard_${idx}`}
                  id="cabCard"
                  className={` tableRowOutline tableRow noBdr ${
                    isShown(cabInfo) ? '' : 'hide'
                  }`}
                >
                  <div
                    className="paddingImportant"
                    style={{
                      width: '100%',
                      display: 'flex',
                      padding: '15px 16px 10px 16px'
                    }}
                    onClick={() => {
                      if (packageAvailabilityOrderMap.has(cabInfo[ORDER_FIELD]))
                        setPackageAvailabilityOrderMap(
                          cabInfo[ORDER_FIELD],
                          !packageAvailabilityOrderMap.get(cabInfo[ORDER_FIELD])
                        );
                    }}
                  >
                    <td
                      className="desktopShow "
                      style={{ border: '1px solid #cecece' }}
                    >
                      <div>
                        <div
                          className={`paddingL30 paddingT16 paddingR30 vertlAlign`}
                        >
                          <div>
                            <img
                              className={`cabImageInCabCard ${
                                idx > 1 ? 'lazyload' : ''
                              }`}
                              src={cabInfo.image_url || ''}
                              data-src={cabInfo.image_url || ''}
                              alt={`${type} image`}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      className="cabCardInfoTdWidth"
                      style={{ border: '1px solid #cecece' }}
                    >
                      <div className="paddingTB15 appendRight20 cabCardInfoWidth">
                        <div className="makeFlex">
                          <div
                            className="mobileShow"
                            style={{ width: '88px' }}
                          ></div>
                          <div>
                            <div className="makeFlex end">
                              <div className=" latoItalic makeFlex end font11 mobileShow">
                                {cabInfo.model_description
                                  ? cabInfo.model_description
                                  : ''}
                              </div>
                            </div>
                            <div className="makeFlex end">
                              <span
                                style={{
                                  marginRight: cabInfo.model_name
                                    ? '5px'
                                    : '0px'
                                }}
                                className={`font16_20 latoBlack lineHeight24 blackText ${
                                  cabInfo.model_name ? `appendRight5` : ``
                                }`}
                              >
                                {cabInfo.model_name
                                  ? getModelNameString(cabInfo.model_name)
                                  : ''}
                              </span>
                              <span
                                className={`latoRegular desktopShow font14 lightGreyText appendBottom3 ${
                                  cabInfo.model_description
                                    ? `appendRight10`
                                    : ``
                                }`}
                              >
                                {cabInfo.model_description
                                  ? getModelDescriptionString(
                                      cabInfo.model_description
                                    )
                                  : ''}
                              </span>
                              {my_safety ? (
                                <span className="appendRight10 makeFlex desktopShowFlex appendBottom3">
                                  <img
                                    height={20}
                                    className="cabCardV2MySafetyIconDimension lazyload"
                                    data-src={MYSAFETY_IMAGE}
                                  ></img>
                                </span>
                              ) : null}
                              {!packageAvailabilityOrderMap.has(
                                cabInfo[ORDER_FIELD]
                              ) ||
                              packageAvailabilityOrderMap.get(
                                cabInfo[ORDER_FIELD]
                              ) == false ? (
                                <div className="desktopShowFlex">
                                  {cabInfo.overall_rating &&
                                  cabInfo.rating_show ? (
                                    <span
                                      style={{ marginRight: '5px' }}
                                      className={`${getColorGradientClassByRating(
                                        cabInfo.overall_rating
                                      )} ratingBoxV2 paddingL2 paddingR4 appendRight5 appendBottom3`}
                                    >
                                      <span
                                        className={`latoBlack whiteText lineHeight18 font14`}
                                      >
                                        {cabInfo.overall_rating}/
                                      </span>
                                      <span
                                        className={`whiteText lineHeight18 font12`}
                                      >
                                        5
                                      </span>
                                    </span>
                                  ) : (
                                    <span
                                      style={{ marginRight: '5px' }}
                                      className={`ratingBox paddingT2 paddingB2 whiteText paddingL2 paddingR4 appendRight5 font14 latoBlack appendBottom3 `}
                                    >
                                      {NEW}
                                    </span>
                                  )}
                                  {cabInfo.rating_count &&
                                  cabInfo.rating_show ? (
                                    <span
                                      className={`font12 lineHeight14 lightGreyText desktopShowFlex vertlCenter`}
                                    >
                                      {cabInfo.rating_count} ratings
                                    </span>
                                  ) : (
                                    <span
                                      className={`font12 lineHeight14 lightGreyText desktopShowFlex vertlCenter`}
                                    >
                                      {NO_RATINGS}
                                    </span>
                                  )}
                                </div>
                              ) : null}
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}
                              className={`appendBottom20 appendTop10`}
                            >
                              <div
                                style={{ flexWrap: 'wrap' }}
                                className={`makeFlex`}
                              >
                                <span
                                  className={`font11_14  lineHeight18 blackText`}
                                >
                                  {getCarTypeForDisplay(cabInfo.type || '')}
                                  &nbsp;&nbsp;&nbsp;
                                </span>
                                <span className="makeFlex appendLeft5 appendRight5  hrtlCenter">
                                  <div className="circleBulletBlack appendRight5"></div>
                                  <div
                                    className={` appendLeft5 blackText font11_14  lineHeight18 latoRegular`}
                                  >
                                    AC &nbsp;&nbsp;&nbsp;{' '}
                                  </div>
                                </span>

                                <span className=" makeFlex appendLeft5 appendRight5 hrtlCenter">
                                  <div className="circleBulletBlack appendRight5"></div>
                                  <div
                                    style={{ whiteSpace: 'nowrap' }}
                                    className={` appendLeft5 blackText font11_14  lineHeight18 latoRegular`}
                                  >
                                    {(() => {
                                      if (cabInfo?.seat_count)
                                        return cabInfo.seat_count;
                                    })()}{' '}
                                    Seats&nbsp;&nbsp;&nbsp;
                                  </div>
                                </span>
                              </div>
                              <div
                                style={{
                                  marginLeft: '10px',
                                  flexShrink: 0,
                                  textAlign: 'left',
                                  maxWidth: '300px',
                                  wordWrap: 'break-word',
                                  opacity: booking_count_persuasion ? 1 : 0,
                                  pointerEvents: booking_count_persuasion
                                    ? 'auto'
                                    : 'none'
                                }}
                              >
                                {booking_count_persuasion && (
                                  <span className="font16 lineHeight18 latoRegular">
                                    {formatBookingPersuasion(
                                      booking_count_persuasion
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="makeFlex end">
                          <div className="dottedHorizontalLine dottedHorizontalMargin  appendBottom10 mobileShow"></div>
                        </div>
                        <div>
                          {cabInfo.overall_rating && cabInfo.rating_show ? (
                            <span
                              style={{ marginRight: '5px', display: 'none' }}
                              className={`${getColorGradientClassByRating(
                                cabInfo.overall_rating
                              )} ratingBoxV2 paddingL2 paddingR4 appendRight5 ratingDisplayForSSRMweb`}
                            >
                              <span
                                className={`latoBlack whiteText lineHeight18 font10`}
                              >
                                {cabInfo.overall_rating}/
                              </span>
                              <span className={`whiteText lineHeight18 font10`}>
                                5
                              </span>
                            </span>
                          ) : (
                            <span
                              style={{ marginRight: '5px' }}
                              className={`ratingBox paddingT2 paddingB2 whiteText paddingL2 paddingR4 appendRight5 font10 latoBlack ratingDisplayForSSRMweb`}
                            >
                              {NEW}
                            </span>
                          )}
                          {packageAvailabilityOrderMap.get(
                            cabInfo[ORDER_FIELD]
                          ) != true && (
                            <div>
                              {cab_description_v2 ? (
                                <div className="font16 latoBlack appendBottom15">
                                  <span
                                    style={{
                                      color:
                                        cab_description_v2?.color || '#00A900',
                                      alignItems: 'center'
                                    }}
                                    className="font16 latoBold"
                                  >
                                    {cab_description_v2?.text}
                                  </span>
                                  {Boolean(cab_description_v2?.icon) && (
                                    <img
                                      className="brandInfoDescriptionIcon lazyload"
                                      data-src={cab_description_v2?.icon || ''}
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className="font12_16 latoBlack blackText appendBottom15">
                                  {cab_description}
                                </div>
                              )}
                              <div>
                                {persuasions &&
                                  persuasions.map((persuasion, idx) => {
                                    const {
                                      title,
                                      icon_url,
                                      text,
                                      highlighted_text,
                                      highlight_color,
                                      tag_icon_url,
                                      tooltip_icon
                                    } = persuasion;
                                    return (
                                      <div
                                        key={`persuasion_${idx}`}
                                        style={{ display: 'flex' }}
                                        className="makeFlex appendBottom10 makeFlex hrtlCenter"
                                      >
                                        <div>
                                          {icon_url || tag_icon_url ? (
                                            <img
                                              className="appendRight10 checkBoxDimensionRouteCabsV2 lazyload"
                                              //alt={`${title}-image`} commented as this was causing SSR in mweb design issue
                                              height={14}
                                              width={14}
                                              data-src={
                                                icon_url || tag_icon_url
                                              }
                                            ></img>
                                          ) : null}
                                        </div>
                                        <div
                                          style={{ display: 'flex' }}
                                          className="makeFlex fullWidth"
                                        >
                                          <div className="font11_14 latoBold blackText cabCardInfoPersuasionTitle appendRight10">
                                            {title}
                                          </div>
                                          <div style={{ width: '60%' }}>
                                            {formatText({
                                              text,
                                              classNameForToolTipIcon:
                                                'appendLeft5 toolTipIcon font12_14',
                                              highlightedText: highlighted_text,
                                              highlightedColor: highlight_color,
                                              classNameForNonHighightedText:
                                                'blackText font12_14',
                                              className:
                                                'latoBold blackText font12_14',
                                              tooltipIcon: tooltip_icon,
                                              idx: idx
                                            }).map(val => val)}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                              <div>
                                {desktop_claim_persuasions &&
                                desktop_claim_persuasions.length ? (
                                  <div className="dottedHorizontalLine appendBottom15"></div>
                                ) : null}
                                {desktop_claim_persuasions &&
                                  desktop_claim_persuasions.map(persuasion => {
                                    const {
                                      title,
                                      icon_url,
                                      text,
                                      highlighted_text,
                                      highlight_color,
                                      tooltip_icon
                                    } = persuasion;

                                    return (
                                      <div
                                        key={`dt_presuasion_${idx}`}
                                        style={{
                                          display: 'flex',
                                          marginRight: '10px'
                                        }}
                                        className="makeFlex makeFlex hrtlCenter appendBottom10"
                                      >
                                        <div
                                          style={{ marginRight: '10px' }}
                                          className="appendRight10"
                                        >
                                          {' '}
                                          <img
                                            height={18}
                                            width={18}
                                            className="checkBoxDimensionRouteCabsV2 lazyload"
                                            alt={`${text}_img`}
                                            data-src={icon_url}
                                          ></img>
                                        </div>
                                        <div>
                                          {formatText({
                                            classNameForToolTipIcon:
                                              'appendLeft5 toolTipIcon',
                                            tooltipIcon: tooltip_icon,
                                            text,
                                            highlightedText: highlighted_text,
                                            highlightedColor: highlight_color,
                                            classNameForNonHighightedText: `blackText 
										${highlighted_text ? 'appendLeft2' : ''}`,
                                            className: 'latoBold blackText',
                                            idx
                                          }).map(val => val)}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td
                      className={`cabCardCtaTdWidth ${
                        isSSR() ? 'vrtlCenter' : 'makeFlex'
                      }`}
                      style={{
                        border: '1px solid #cecece',
                        alignContent: 'center'
                      }}
                    >
                      <div
                        className={` pushRightBottom  paddingL15 ctaInfoWidth paddingR20`}
                        style={{
                          marginTop:
                            packageAvailabilityOrderMap.get(
                              cabInfo[ORDER_FIELD]
                            ) == true
                              ? '20px'
                              : 'auto',
                          marginBottom:
                            packageAvailabilityOrderMap.get(
                              cabInfo[ORDER_FIELD]
                            ) == true
                              ? '20px'
                              : 'auto'
                        }}
                      >
                        <div style={{ display: 'grid' }}>
                          <div>
                            <div className="pushRight">
                              <div
                                className={`pushRightBottom redText pushRight font12_14 paddingB5`}
                              >
                                <span>{strike_off_discount_textV2}</span>
                              </div>
                              <div
                                className={`pushRightBottom appendBottom12 pushRight`}
                              >
                                <span
                                  className={`strikeDiagonal font12 lightGreyText latoRegular appendRight10 pushBottom`}
                                >
                                  {cabInfo.strike_off_amount
                                    ? `₹ ${cabInfo.strike_off_amount}`
                                    : ``}
                                </span>
                                <span className={`cabsV2TypePrice blackText`}>
                                  {cabInfo.total_amount
                                    ? `₹ ${cabInfo.total_amount}`
                                    : ``}
                                </span>
                              </div>
                              <div>
                                {cabInfo?.tolls_and_taxes_text ? (
                                  <p
                                    className={`font13 pushRightBottom appendBottom20`}
                                  >
                                    {cabInfo?.tolls_and_taxes_text}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          {packageAvailabilityOrderMap.has(
                            cabInfo[ORDER_FIELD]
                          ) ? (
                            <div
                              className={`pushRightBottom pushRight appendBottom10 appendTop10 desktopShow`}
                            >
                              <a
                                className={`latoBold font12 ${
                                  packageAvailabilityOrderMap.get(
                                    cabInfo[ORDER_FIELD]
                                  ) == true
                                    ? 'viewCabBtnHide'
                                    : 'viewCabBtnShow'
                                }`}
                                href={cabInfo.reviewURL}
                                onClick={e => {
                                  trackTemplateEvent(
                                    `Cab_SEO_Route_${cabInfo.type}_Book_Isomorph_Cab_Click`
                                  );
                                  e.preventDefault();
                                }}
                              >
                                {packageAvailabilityOrderMap.get(
                                  cabInfo[ORDER_FIELD]
                                ) == false
                                  ? VIEW_PRICES
                                  : HIDE_PRICES}
                                {packageAvailabilityOrderMap.get(
                                  cabInfo[ORDER_FIELD]
                                ) == false ? (
                                  <span className="appendLeft10 arrow arrow-down-wide whiteBorder appendTop0"></span>
                                ) : (
                                  <span className="appendLeft10 arrow arrow-top-wide azureBlueBorder"></span>
                                )}
                              </a>
                            </div>
                          ) : (
                            <div
                              className={`pushRightBottom pushRight appendBottom10 appendTop10 desktopShow`}
                            >
                              <a
                                className="viewCabBtnBook font12 latoBold"
                                href={reviewURL}
                                onClick={e => {
                                  trackTemplateEvent(
                                    `Cab_SEO_Route_${cabInfo.type}_Book_Isomorph_Cab_Click`
                                  );
                                  e.preventDefault();
                                  redirect(reviewURL);
                                }}
                              >
                                {BOOK_NOW}
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </div>
                  {packageAvailabilityOrderMap.get(cabInfo[ORDER_FIELD]) ==
                    true && (
                    <div className="cabPackageContainer cabListTileExtension">
                      <div
                        style={{ display: 'flex', width: '100%' }}
                        className="makeFlex"
                      >
                        {cabInfo &&
                          cabInfo.packages &&
                          cabInfo.packages.map((cabPackage, idx) => {
                            return (
                              <RouteCabsFareCards
                                cabPackage={cabPackage}
                                idx={idx}
                              />
                            );
                          })}
                      </div>
                    </div>
                  )}
                </tr>
                {isDesktop() &&
                cabInfo[ORDER_FIELD] == getFirstVisibleCardIndex() &&
                tripBenefits &&
                tripBenefits.length > 0 ? (
                  <tr id="tripBenefits-section">
                    <div
                      className="tripBenefits desktopShow"
                      style={{ width: 940 }}
                    >
                      <div
                        style={{ display: 'flex' }}
                        className="makeFlex spaceBetween appendBottom10 font20 blackText latoBlack"
                      >
                        <p>{WHY_BOOK_WITH_US_TEXT}</p>
                      </div>
                      <div
                        style={{ overflow: 'scroll', display: 'flex' }}
                        className="makeFlex "
                      >
                        {tripBenefits.map((tripBenefitInfo, idx) => {
                          return (
                            <div
                              key={`benefits_${idx}`}
                              style={{ display: 'flex' }}
                              className="tripBenefitCard2 makeFlex"
                            >
                              <span className="iconSpan">
                                <img
                                  src={tripBenefitInfo.icon}
                                  className="icon"
                                  height={46}
                                  width={46}
                                />
                              </span>
                              <div className="appendLeft5">
                                <p className="title latoBold font16 blackText appendBottom5 inlineBlock">
                                  {tripBenefitInfo.title}
                                </p>
                                <p className="subTitle lightGreyText inlineBlock">
                                  {tripBenefitInfo.subTitle}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </tr>
                ) : null}
              </>
            );
          })}
      </tbody>
    </table>
  );
};
